import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { BUYERS } from '../data/buyers';
const MINUTES = [2, 3, 5, 7, 8, 11, 14, 18];
export function PurchasePopup() {
  const [index, setIndex] = useState<number>(0);
  const [visible, setVisible] = useState<boolean>(false);
  const [dismissed, setDismissed] = useState<boolean>(false);
  useEffect(() => {
    if (dismissed) return;
    let hideId = 0;
    const showId = window.setInterval(() => {
      setVisible(true);
      hideId = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % BUYERS.length);
      }, 5000);
    }, 9000);
    const firstId = window.setTimeout(() => setVisible(true), 3500);
    return () => {
      window.clearInterval(showId);
      window.clearTimeout(hideId);
      window.clearTimeout(firstId);
    };
  }, [dismissed]);
  if (dismissed || !visible) return null;
  const buyer = BUYERS[index];
  const minutes = MINUTES[index % MINUTES.length];
  return <div role="status" aria-live="polite" className="animate-pop-in fixed bottom-2 left-2 z-50 max-w-[230px] rounded-lg border-2 border-cta bg-white p-2 pr-6 shadow-[0_6px_20px_rgba(0,0,0,0.35)] sm:max-w-[260px]" data-id="element-190" data-mp="164xq93086yn7">
      <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-0.5 top-0.5 rounded-full p-0.5 text-night/40 transition-colors duration-150 ease-out hover:bg-night/10 hover:text-night" data-id="element-191" data-mp="1fuhc8hj8j8ma">
        <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-192" data-mp="i81tlcf2o4x5" />
      </button>

      <div className="flex items-start gap-1.5" data-id="element-193" data-mp="i9uz2ody8j3k">
        <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cta/20" data-id="element-194" data-mp="x5u8q3gpirat">
          <CheckCircle2Icon className="h-3.5 w-3.5 text-cta-dark" aria-hidden="true" data-id="element-195" data-mp="s5yc4paca25a" />
        </span>
        <div data-id="element-196" data-mp="28jojc4wr96j5">
          <p className="text-[10px] font-bold leading-tight text-night" data-id="element-197" data-mp="28j508kvdcc3j">
            {buyer.name} — {buyer.city}, {buyer.country}
          </p>
          <p className="text-[10px] leading-snug text-night/70" data-id="element-198" data-mp="23nps89k1laf1">
            just purchased{' '}
            <span className="font-bold text-brand" data-id="element-199" data-mp="2aqxj2gp6i4bk">Spanish Teacher Pro™</span>
          </p>
          <p className="text-[8px] font-semibold uppercase tracking-wide text-night/45" data-id="element-200" data-mp="2fpqxcbcahzcs">
            {minutes} minutes ago · Verified
          </p>
        </div>
      </div>
    </div>;
}